export default "__VITE_ASSET__CGbQ40W9__"